<template>
  <span>
    <b-modal id="modalInvoice" size="lg" title="Invoice">
      <div slot="modal-footer" class="w-100">
        <b-btn size="sm" class="float-right" variant="warning" @click="print">
          <i class="fa fa-print"></i> Print
        </b-btn>
      </div>
    </b-modal>
    <b-button v-b-modal="'modalInvoice'">Show Modal</b-button>
  </span>
</template>

<script>
export default {
  name: "print",
  methods: {
    print() {
      const modal = document.getElementById("modalInvoice");
      const cloned = modal.cloneNode(true);
      let section = document.getElementById("print");

      if (!section) {
        section = document.createElement("div");
        section.id = "print";
        document.body.appendChild(section);
      }

      section.innerHTML = "";
      section.appendChild(cloned);
      window.print();
    }
  }
};
</script>

<style>
@media screen {
  #print {
    display: none;
  }
}

@media print {
  body * {
    visibility: hidden;
  }
  #print,
  #print * {
    visibility: visible;
  }
  #print {
    position: absolute;
    left: 0;
    top: 0;
  }
}
</style>
